
// Locations.js
import {
    useState,
    useEffect
} from "react";

import {
    useDispatch,
    useSelector
} from "react-redux";

import {
    Button,
    SaveButton,
    CancelButton,
    Slider,
    TextInput,
    CheckBox
} from "../components/Input";

import { 
    showMsg,
    hideMsg,
    setLoadingNow,
    setLoadingComplete,
    pageSelector 
} from "../store/pageSlice";

import {
    GetLocations,
    AddLocation,
    UpdateLocation,
    DeleteLocation
} from "../api/location";

import Help from "./Help";

import "../App.css";
import "./Locations.css";

import { importLibrary } from "@googlemaps/js-api-loader";


export default function Locations() {
    let debounceTimer = null;

    const triggerSearchDebounce = (value) => {
        if (debounceTimer) clearTimeout(debounceTimer);

        // wait 500ms after typing stops
        debounceTimer = setTimeout(() => {
            if (value.trim() !== "") {
                setIsSearchMap(true);
            }
        }, 500);
    };

    const dispatch = useDispatch();
    const pageSel = useSelector(pageSelector);

    const [ds, setDs] = useState([]);

    const [lst, setLst] = useState();
    const [lstSearchMap, setLstSearchMap] = useState([]);

    const [map, setMap] = useState(null);
    const [mapLocation, setMapLocation] = useState([ 1.549384, 103.786228 ]);

    const [rad, setRad] = useState(null);
    const [mapPoint, setMapPoint] = useState();

    const [search, setSearch] = useState("");

    const [searchMap, setSearchMap] = useState("");

    const [selLocation, setSelLocation] = useState(defaultLocation);

    const [isCancel, setIsCancel] = useState(false);
    const [isSearchMap, setIsSearchMap] = useState(false);

    const [isKM, setIsKM] = useState(false);

    const refreshList = async () => {
        dispatch(setLoadingNow());

        try {
            const dsLoc = await GetLocations();
            setDs(dsLoc);
        } catch (ex) {
            dispatch(showMsg({
                title: "Error",
                content: `Unable to retrieve location list. ${ ex.message }`
            }));
        } finally {
            dispatch(setLoadingComplete());
        }
    };

    const updateMap = (e) => {
        map.setCenter({ lat: Number(e[0]), lng: Number(e[1]) });
        mapPoint.position = { lat: Number(e[0]), lng: Number(e[1]) };
    };

    const renderList = () => {
        let dsTemp = ds.map((row) => row);

        if (search !== "") {
            const srch = search.toLowerCase();

            dsTemp = dsTemp.filter((row) => {
                return row.locationCode.toLowerCase().indexOf(srch) > -1 ||
                    row.description.toLowerCase().indexOf(srch) > -1;
            });
        }

        const locLst = dsTemp.map((row) => (
            <div key={ row.id } className="listing-row" onClick={() => { onSelection(row) }}>
                <strong>{ row.locationCode }</strong>
                <span>{ row.description }</span>
            </div>
        ));

        setLst(locLst);
    };

    const onSelection = (e) => {
        const { radiusFence } = e;

        if (Number(radiusFence) >= 1000) {
            setIsKM(true);
        } else {
            setIsKM(false);
        }

        setMapLocation([ Number(e.latitude), Number(e.longitude) ]);
        setSelLocation(e);

    };

    const onFieldChange = (e, field) => {
        if (field === "LOCATION_CODE") {
            setSelLocation({
                ...selLocation,
                locationCode: e
            });
        } else if (field === "DESCRIPTION") {
            setSelLocation({
                ...selLocation,
                description: e
            });
        } else if (field === "LATITUDE") {
            setSelLocation({
                ...selLocation,
                latitude: e
            });
        } else if (field === "LONGITUDE") {
            setSelLocation({
                ...selLocation,
                longitude: e
            });
        } else if (field === "MANDATORY_QR_CODE") {
            setSelLocation({
                ...selLocation,
                mandatoryQRCode: e
            });
        } else if (field === "RADIUS_FENCE") {
            setSelLocation({
                ...selLocation,
                radiusFence: e
            });
        } else if (field === "USE_DESC_ADDRESS") {
            setSelLocation({
                ...selLocation,
                useDescAddress: e
            });
        }
    };

    const onSave = async (e) => {
        e.preventDefault();

        if (isCancel || isSearchMap) {
            return;
        }

        dispatch(setLoadingNow());

        try {
            const lat = mapLocation[0].toString();
            const longi = mapLocation[1].toString();

            const locDat = {
                ...selLocation,
                latitude: lat,
                longitude: longi
            };

            if (selLocation.id === "-1") {
                const newDat = {
                    locationCode: locDat.locationCode,
                    description: locDat.description,
                    latitude: locDat.latitude,
                    longitude: locDat.longitude,
                    mandatoryQRCode: locDat.mandatoryQRCode,
                    radiusFence: locDat.radiusFence,
                    useDescAddress: locDat.useDescAddress
                };

                await AddLocation(newDat);
            } else {
                await UpdateLocation(locDat);
            }

            await refreshList();

            dispatch(showMsg({
                title: "Success",
                content: "Changes successfully saved."
            }));
        } catch (ex) {
            dispatch(showMsg({
                title: "Error",
                content: `Unable to save changes. ${ ex.message }`
            }));
        } finally {
            dispatch(setLoadingComplete());
        }
    };

    const onSearchMap = async (query) => {

        const text = query ?? searchMap; // fallback if query not passed

        // --- FIX: When input is empty, clear dropdown & do nothing ---
        if (searchMap.trim() === "") {
            setLstSearchMap([]);  // Close dropdown
            return;
        }

        dispatch(setLoadingNow());

        try {
            const reqUrl = `https://places.googleapis.com/v1/places:searchText`;
            
            const res = await fetch(reqUrl, {
                        method: 'POST',
                        body: JSON.stringify({ textQuery: `${searchMap}` }),
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Goog-Api-Key': 'AIzaSyDwAZ5j5Dfg8iFxgdqvtrbrFh4RkYaz_1M',
                            
                            // --- THIS IS THE FIX ---
                            // Specify the fields you want, separated by a comma.
                            'X-Goog-FieldMask': 'places.displayName,places.formattedAddress,places.location,places.id'
                        }
                        });

            if (!res.ok) {
                throw new Error(await res.text());
            }

            let searchRes = await res.json();

            if (!searchRes.places || searchRes.places.length === 0) {
                setLstSearchMap([]); // don't show popup
                return;
            }

            searchRes = searchRes.places;

            const lst = searchRes.map((row) => (
                <div key={row.id} className="listing-row"
                    onClick={() => {
                        onSearchMapClick([Number(row.location.latitude), Number(row.location.longitude)]);
                        setLstSearchMap([]);     // Close dropdown
                    }}>
                    <strong>{row.displayName.text}</strong>
                    <span>{row.formattedAddress}</span>
                </div>
            ));

            setLstSearchMap(lst);
        } catch (ex) {
            dispatch(showMsg({
                title: "Error",
                content: `An error occured during map search. ${ ex.message }`
            }));
        } finally {
            setIsSearchMap(false);
            dispatch(setLoadingComplete());
        }
    };

    const onSearchMapClick = (e) => {
        updateMap(e);
        rad.setCenter({ lat: Number(e[0]), lng: Number(e[1]) });
        setMapLocation(e);
    };

    const onDelete = () => {
        if (selLocation.id === "-1") {
            return;
        }

        dispatch(showMsg({
            title: "Deleting...",
            content: `Are you sure want to delete location ${ selLocation.locationCode }?`,
            id: "DEL_LOCATION",
            isPromptInput: true
        }));
    };

    const onCloseSearchMap = () => {
        setLstSearchMap([]);
    };

    const initMap = (Map, AdvancedMarkerElement, Circle, ControlPosition, MapTypeControlStyle, MapTypeId) => {
        try {
            const mapEl = document.getElementById("map");
            const radPoint = new Circle({
                    strokeColor: "#0031b6ff",
                    strokeOpacity: 0.8,
                    strokeWeight: 1,
                    fillColor: "#00b1b6",
                    fillOpacity: 0.35,
            });
            const mapOptions = {
                center: { lat: Number(defaultLocation.latitude), lng: Number(defaultLocation.longitude) },
                zoom: 19,
                mapId: '54b90abfc490b9b780eacd01',
                gestureHandling: "greedy",
                zoomControl: true,
                zoomControlOptions: {
                    position: ControlPosition.RIGHT_BOTTOM
                },

                fullscreenControl: false,
                cameraControl : false,
                streetViewControl: false,
                mapTypeControlOptions: {
                    style: MapTypeControlStyle.DROPDOWN_MENU,
                    position: ControlPosition.RIGHT_TOP,
                    mapTypeIds: [MapTypeId.ROADMAP, MapTypeId.SATELLITE, MapTypeId.HYBRID, MapTypeId.TERRAIN]
                }
            };
            const map = new Map(mapEl, mapOptions)


            const mapPoint = new AdvancedMarkerElement({
                map: map,
                position: { lat: Number(defaultLocation.latitude), lng: Number(defaultLocation.longitude) },
                gmpDraggable: true,
            });

            

            map.addListener("click", (e) => {
                const position = { lat: e.latLng.lat(), lng: e.latLng.lng() };

                setMapLocation([ position.lat, position.lng ]);

                radPoint.setCenter(position);
            });

            mapPoint.addListener('dragend', (event) => {
                const position = mapPoint.position;

                setMapLocation([ position.lat, position.lng ]);

                radPoint.setCenter(position);
            });




            radPoint.setMap(map);
            radPoint.setCenter({ lat: Number(defaultLocation.latitude), lng: Number(defaultLocation.longitude) });
            radPoint.setRadius(defaultLocation.radiusFence);

            setMap(map);
            setMapPoint(mapPoint);
            setRad(radPoint);
            
    } catch (ex) {
        console.error("Error init", ex);
    }
    };

    useEffect(() => {
        
        const loadMap = async () => {
        try {
            
            const { Map, Circle, MapTypeControlStyle, MapTypeId } = await importLibrary("maps");

            const { ControlPosition } = await importLibrary("core");
            
            const { AdvancedMarkerElement} = await importLibrary("marker");

            initMap(Map, AdvancedMarkerElement, Circle, ControlPosition, MapTypeControlStyle, MapTypeId);

            await refreshList(); 
        } catch (e) {
            console.error("Error loading Google Maps libraries", e);
        }
        };

        loadMap();
    }, []);

    useEffect(() => { renderList() }, [ds, search]);

    useEffect(() => {
        if (map === null || map === undefined || 
            mapPoint === null || mapPoint === undefined ||
            rad === null || rad === undefined) {
            return;
        }

        updateMap(mapLocation);

    }, [mapLocation]);

    useEffect(() => {
        if (rad === null || rad === undefined) {
            return;
        }

        rad.setCenter({ lat: Number(mapLocation[0]), lng: Number(mapLocation[1]) });
        rad.radius = Number(selLocation.radiusFence);
    }, [selLocation.radiusFence]);

    useEffect(() => {
        if (!isSearchMap) {
            return;
        }

        const reg = /^[\d\.]+,\s*[\d\.]+\s*$/g;

        if (reg.exec(searchMap)) {
            const coorSrch = searchMap.split(",");

            if (coorSrch.length === 0) {
                setIsSearchMap(false);
                return;
            }

            const coorLat = coorSrch[0];
            const coorLong = coorSrch[1];

            onSearchMapClick([ Number(coorLat), Number(coorLong) ]);

            setIsSearchMap(false);
            
            return;
        }

        (
            async () => { await onSearchMap() }
        )();
    }, [isSearchMap]);

    useEffect(() => {
        if (!pageSel.msgResult) {
            return;
        }

        (
            async () => {
                dispatch(setLoadingNow());

                try {
                    if (pageSel.msgId === "DEL_LOCATION") {
                        await DeleteLocation(selLocation.id);

                        await refreshList();

                        onSelection(defaultLocation);

                        dispatch(hideMsg());
                    }
                } catch (ex) {
                    dispatch(showMsg({
                        title: "Error",
                        content: `Unable to proceed. ${ ex.message }`
                    }));
                } finally {
                    dispatch(setLoadingComplete());
                }
            }
        )();
    }, [pageSel.msgResult]);

    return (
        <>
            <strong className="title">Locations</strong>
            <div className="panel-horizontal">
                <div className="panel-inner panel-inner-start">
                    <Button src="/img/refresh.svg" onClick={async () => { await refreshList() }}/>
                    <Button label="New" src="/img/add.svg" onClick={() => { onSelection(defaultLocation) }}/>
                    <Button label="Delete" src="/img/remove.svg" onClick={ onDelete }/>
                </div>
                <div className="panel-inner panel-inner-end"></div>
            </div>
            <div className="side-panel location-side-panel">
                <div className="form-section">
                    <strong>Details</strong>
                </div>
                <div className="search-map">
                    <input
                        className="listing-search-box listing-search-map"
                        type="text"
                        placeholder="Search address…"
                        value={searchMap}
                        onChange={(e) => {
                            setSearchMap(e.target.value);
                            triggerSearchDebounce(e.target.value); // auto-search
                            onSearchMap(e.target.value);
                        }}
                    />

                    {/* ▼ Search results dropdown */}
                    {lstSearchMap.length > 0 && (
                        <div className="search-map-dropdown">
                            {lstSearchMap}
                        </div>
                    )}
                </div>
                <div id="map" className="map"></div>
                <form onSubmit={ onSave }>
                    <div className="radius-slider">
                        <Slider 
                            label="Fence Coverage" 
                            unit={ !isKM ? "Meters" : "KM" }
                            min={ !isKM ? 10 : 1 }
                            max={ !isKM ? 999 : 10}
                            step={ !isKM ? 1 : 0.1 }
                            initValue={ !isKM ? selLocation.radiusFence : selLocation.radiusFence / 1000 }
                            onChange={(e) => { 
                                const radKm = !isKM ? e : e * 1000;
                                onFieldChange(radKm, "RADIUS_FENCE");
                            }}
                        />
                        <div className="radius-toggle">
                            <CheckBox 
                                label="in KM" 
                                checked={ isKM } 
                                onChange={() => { 
                                    let radKm;

                                    if (isKM === false) {
                                        // change to KM
                                        radKm = selLocation.radiusFence <= 999 ? 1000 : selLocation.radiusFence;
                                    } else {
                                        // change to M
                                        radKm = selLocation.radiusFence >= 999 ? 999 : selLocation.radiusFence;
                                    }

                                    onFieldChange(radKm, "RADIUS_FENCE");

                                    setIsKM(!isKM);
                                }}
                            />
                        </div>
                    </div>
                    <div className="form-row">
                        <TextInput label="Code" required value={ selLocation.locationCode } onChange={(e) => { onFieldChange(e, "LOCATION_CODE") }}/>
                        <TextInput label="Description" value={ selLocation.description } onChange={(e) => { onFieldChange(e, "DESCRIPTION") }}/>
                    </div>
                    <div className="form-row">
                        <CheckBox
                            label="Use Location Description as Address"
                            checked={selLocation.useDescAddress}
                            onChange={() => { onFieldChange(!selLocation.useDescAddress, "USE_DESC_ADDRESS") }}
                        />
                    </div>
                    <div className="form-row">
                        <CheckBox 
                            label="QR Code Require" 
                            checked={ selLocation.mandatoryQRCode } 
                            onChange={() => { onFieldChange(!selLocation.mandatoryQRCode, "MANDATORY_QR_CODE") }}
                        />
                    </div>
                    <div className="form-row form-row-border-top">
                        <div className="form-row" style={{ padding: 0 }}>
                            <SaveButton /> 
                            <CancelButton onClick={() => { setIsCancel(true) }}/>
                        </div>
                    </div>
                </form>
            </div>
            <div className="listing">
                <input className="listing-search-box" type="text" placeholder="search" onChange={(e) => { setSearch(e.target.value) }}/>
                <div>
                    { lst }
                </div>
            </div>
            <Help sectionName="Locations">
                <h3>Geo-Fencing Location</h3>
                <p>Geo-fencing location is a feature used by iFlexi Clock to limit location allowed to perform clocking.</p>
                <h3>Define New Location</h3>
                <ul>
                    <li>To define new location, click on <strong>"New"</strong> button.</li>
                    <li>Click on location on the map.</li>
                    <li>To ease your location searching, enter <strong>street name</strong> or <strong>point of interest</strong> 
                    in the search box above the map and click on <img  src="/img/search.svg" /> button.</li>
                    <li>Click on result display then hold-click to move the map around.</li>
                    <li>Single-click on the map to select location for geo-fencing.</li>
                    <li>To increase the size of clocking coverage, drag <strong>"Fence Coverage"</strong> slider.</li>
                    <li>Enter particulars.</li>
                    <li>Click <strong>"Save"</strong> to confirm.</li>
                </ul>
                <h3>Use location's description as clock data address</h3>
                <ul>
                    <li>By enabling <strong>"Use Location Description as Address"</strong>, iFlexi Clock mobile app. will use defined description as location address if user is within location radius.</li>
                    <li>This option will affect all users, regardless of geo-fencing setting.</li>
                </ul>
                <h3>Delete Location</h3>
                <ul>
                    <li>To delete simply click on desire location from the location listing.</li>
                    <li>Click <strong>"Delete"</strong> button.</li>
                </ul>
            </Help>
        </>
    );
}

const defaultLocation = {
    id: "-1",
    locationCode: "",
    description: "",
    latitude: "1.549384 ",
    longitude: "103.786228",
    mandatoryQRCode: false,
    radiusFence: Number(10),
    useDescAddress: false
};